import React, { useEffect, useState } from "react";
import { tasksApi } from "@api/tasks";

const LEVEL = {
  INFO: "text-[#374151]",
  WARNING: "text-[#B45309]",
  ERROR: "text-[#B91C1C]",
  SUCCESS: "text-[#1F7A3A]",
};

export default function TaskLogsModal({ open, onClose, taskUid }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !taskUid) return;

    let alive = true;
    const load = async () => {
      setLoading(true);
      try {
        const data = await tasksApi.logs(taskUid, 300);
        if (alive) setLogs(data || []);
      } finally {
        if (alive) setLoading(false);
      }
    };

    load();
    const t = setInterval(load, 2000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [open, taskUid]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60]">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="absolute inset-0 grid place-items-center px-4">
        <div className="w-full max-w-[760px] bg-white rounded-[18px] border border-[#C8C8C8] shadow-[0_12px_28px_rgba(0,0,0,0.12)] p-6">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="text-[18px] font-semibold text-[#111827]">
                Логи задачи #{taskUid}
              </h3>
              <p className="mt-1 text-[12px] text-[#6B7280]">
                {loading ? "Обновление..." : `Записей: ${logs.length}`}
              </p>
            </div>

            <button
              className="w-9 h-9 rounded-full bg-[#F3F4F6] grid place-items-center hover:bg-[#EDEFF3] transition"
              onClick={onClose}
              title="Закрыть"
              type="button"
            >
              <i className="fa-solid fa-xmark text-[#111827]" />
            </button>
          </div>

          <div className="mt-4 h-[420px] overflow-auto rounded-[14px] border border-[#E5E7EB] bg-[#FAFAFB] p-3">
            {logs.length === 0 ? (
              <div className="text-sm text-[#6B7280]">Логов пока нет</div>
            ) : (
              <div className="grid gap-2">
                {logs.map((l, idx) => (
                  <div key={idx} className="text-[12px] leading-[1.35]">
                    <span className="text-[#9CA3AF]">
                      {new Date(l.createdAt).toLocaleString()}{" "}
                    </span>
                    <span className={LEVEL[l.level] || "text-[#374151]"}>
                      [{l.level}] {l.message}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="mt-4 flex justify-end">
            <button
              className="h-10 px-5 rounded-full border border-[#C8C8C8] bg-white hover:bg-[#F9FAFB] transition text-sm font-medium"
              onClick={onClose}
              type="button"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
